/** Build-time CMS entry gate; backend authentication and staff roles remain authoritative. */
export function artistHubAvailable(projectId: string | undefined, configured: string | undefined): boolean {
  if (projectId !== "onreel-sandbox" && projectId !== "onreel-dev") return false;
  if (configured !== undefined) return configured === "true";
  return projectId === "onreel-sandbox";
}
